type CacheEnvelope<T> = {
    savedAt: number;
    data: T;
};

const keyFor = (file: string) => `runtime-json-cache:${file}`;

export function saveRuntimeJsonCache<T>(file: string, data: T) {
    try {
        const payload: CacheEnvelope<T> = {
            savedAt: Date.now(),
            data,
        };

        localStorage.setItem(keyFor(file), JSON.stringify(payload));
    } catch {

    }
}

export function loadRuntimeJsonCache<T>(file: string): T | null {
    try {
        const raw = localStorage.getItem(keyFor(file));
        if (!raw) return null;

        const parsed = JSON.parse(raw) as Partial<CacheEnvelope<T>>;
        if (!parsed || typeof parsed !== 'object' || !('data' in parsed)) {
            return null;
        }

        return parsed.data as T;
    } catch {
        return null;
    }
}